var exports = {
  "x": "ExpiryFootnote.module__footnote___dnlMWD",
  "m": "ExpiryFootnote.module__inlineFootnote___dnlMWD",
};

module.exports = exports;
